export const siteAdministratorsKeys = {
  all: ['site', 'administrators'] as const,
  lists: () => [...siteAdministratorsKeys.all, 'list'] as const,
  list: (siteToken: string, page: number, perPage: number) =>
    [...siteAdministratorsKeys.lists(), siteToken, { page, perPage }] as const,
};
